import React from 'react';

import { TextInput } from '@mantine/core';

const RuStorePackage = ({ packageName, onChange }) => (
    <TextInput
        id="rustore_package"
        label="Название пакета RuStore"
        onChange={onChange}
        value={packageName}
        placeholder="com.elex.twdsaw.juefeng.rustore"
        mt={6}
    />
);

export default RuStorePackage;
